// Estilos do modal de templates de diagrama (lista + preview)
const styles = (theme) => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  // Colunas lado a lado ocupando a altura do dialog
  dialogContent: {
    display: "flex",
    gap: 2,
    height: "calc(82vh - 120px)",
    overflow: "hidden",
  },
  listColumn: {
    width: 320,
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minHeight: 0,
  },
  filtroField: { flexShrink: 0 },
  // Lista rolável com altura controlada pela coluna
  listBox: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  itemBox: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    p: 1,
    borderRadius: 2,
    border: `1px solid ${theme?.palette?.divider}`,
    backgroundColor: theme?.palette?.background?.default,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme?.palette?.action?.hover,
    },
  },
  itemBoxSelected: {
    borderColor: theme?.palette?.primary?.main,
    backgroundColor: theme?.palette?.action?.selected,
  },
  itemInfo: { flex: 1, minWidth: 0 },
  itemNome: {
    fontSize: 13,
    fontWeight: 600,
    color: theme?.palette?.text?.primary,
  },
  itemDescricao: {
    fontSize: 12,
    color: theme?.palette?.text?.secondary,
    wordBreak: "break-word",
  },
  itemMeta: {
    fontSize: 11,
    color: theme?.palette?.text?.secondary,
  },
  itemActions: { display: "flex", flexShrink: 0 },
  detailColumn: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minHeight: 0,
  },
  detailHeader: { flexShrink: 0 },
  detailNome: {
    fontSize: 16,
    fontWeight: 600,
    color: theme?.palette?.text?.primary,
  },
  detailDescricao: {
    fontSize: 13,
    color: theme?.palette?.text?.secondary,
    wordBreak: "break-word",
  },
  // O TemplatePreview (previewBox) faz flex: 1 entre header e botão
  aplicarBox: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
  },
  aplicarHint: {
    fontSize: 11,
    color: theme?.palette?.text?.secondary,
    textAlign: "center",
  },
  loadingBox: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  emptyText: {
    fontSize: 13,
    color: theme?.palette?.text?.secondary,
    textAlign: "center",
    p: 2,
  },
  previewPlaceholder: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 2,
    border: `1px dashed ${theme?.palette?.divider}`,
  },
});

export default styles;
